import { useState } from "react";
import Input from "../components/Input"; 
import { T } from "../constants/theme";
import Btn from "../components/Btn";
import Badge from "../components/Badge";
export default function Dashboard ({ user, onLogout })  {
  const [active, setActive] = useState("dashboard");

  const navItems = [
    { id: "dashboard", label: "Dashboard", icon: "🏠" },

    { id: "profile", label: "My Profile", icon: "👤" },

    { id: "mock", label: "Mock Tests", icon: "📝" },

    { id: "monthly", label: "Monthly Exams", icon: "📅" },

    { id: "reports", label: "Performance", icon: "📈" },

    { id: "updates", label: "Exam Updates", icon: "🔔" },

    { id: "certs", label: "Certificates", icon: "🏆" },
  ];

  const upcomingExam = {
    title: "Mock Test 1",

    date: "20 June 2026",

    time: "10:00 AM",

    duration: "90 min",
  };

  const tiles = [
    { label: "Mock Tests", value: "3 Available", icon: "📝", color: T.saffron },

    {
      label: "Monthly Exams",

      value: "Starts Jul 2026",

      icon: "📅",

      color: T.indigo,
    },

    { label: "Your Rank", value: "Not Attempted", icon: "🏆", color: T.green },

    { label: "Reports", value: "0 Completed", icon: "📈", color: "#7C3AED" },
  ];

  const renderContent = () => {
    if (active === "profile")
      return (
        <div>
          <h3
            style={{
              fontSize: 17,

              fontWeight: 800,

              color: T.indigo,

              marginBottom: 16,
            }}
          >
            My Profile
          </h3>

          <div
            style={{
              background: T.gray50,

              borderRadius: 12,

              padding: "18px 20px",
            }}
          >
            <div
              style={{
                display: "flex",

                alignItems: "center",

                gap: 14,

                marginBottom: 18,
              }}
            >
              <div
                style={{
                  width: 56,

                  height: 56,

                  borderRadius: 10,

                  background: T.saffron + "22",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  fontSize: 24,
                }}
              >
                👤
              </div>

              <div>
                <div style={{ fontWeight: 800, color: T.indigo }}>
                  {user.username}
                </div>

                <div style={{ fontSize: 13, color: T.gray600 }}>
                  Student · Shabbas Academy
                </div>
              </div>
            </div>

            <p style={{ fontSize: 13, color: T.gray600 }}>
              Profile editing will be available after your full registration
              data is verified.
            </p>
          </div>
        </div>
      );

    if (active === "mock")
      return (
        <div>
          <h3
            style={{
              fontSize: 17,

              fontWeight: 800,

              color: T.indigo,

              marginBottom: 16,
            }}
          >
            Mock Tests
          </h3>

          {[1, 2, 3].map((n) => (
            <div
              key={n}
              style={{
                background: T.gray50,

                borderRadius: 10,

                padding: "14px 16px",

                marginBottom: 10,

                display: "flex",

                justifyContent: "space-between",

                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontWeight: 700, color: T.gray800 }}>
                  Mock Test {n}
                </div>

                <div style={{ fontSize: 12, color: T.gray600 }}>
                  90 Minutes · Full Syllabus
                </div>
              </div>

              <span
                style={{
                  background: n === 1 ? T.saffron : T.gray200,

                  color: n === 1 ? T.white : T.gray600,

                  fontSize: 12,

                  fontWeight: 700,

                  padding: "4px 12px",

                  borderRadius: 99,
                }}
              >
                {n === 1 ? "Available" : "Locked"}
              </span>
            </div>
          ))}
        </div>
      );

    if (active === "updates")
      return (
        <div>
          <h3
            style={{
              fontSize: 17,

              fontWeight: 800,

              color: T.indigo,

              marginBottom: 16,
            }}
          >
            Exam Updates
          </h3>

          {[
            {
              title: "Mock Test 1 Schedule Released",

              date: "10 Jun 2026",

              tag: "New",
            },

            {
              title: "Monthly Exam – July 2026 Guidelines",

              date: "5 Jun 2026",

              tag: "Info",
            },

            {
              title: "Guidance Seminar: Registration Open",

              date: "1 Jun 2026",

              tag: "Event",
            },
          ].map((n, i) => (
            <div
              key={i}
              style={{
                padding: "12px 0",

                borderBottom: `1px solid ${T.gray100}`,
              }}
            >
              <div
                style={{
                  display: "flex",

                  justifyContent: "space-between",

                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    fontSize: 14,

                    fontWeight: 600,

                    color: T.gray800,

                    flex: 1,
                  }}
                >
                  {n.title}
                </div>

                <Badge
                  color={
                    n.tag === "New"
                      ? T.saffron
                      : n.tag === "Event"
                        ? T.green
                        : T.indigo
                  }
                >
                  {n.tag}
                </Badge>
              </div>

              <div style={{ fontSize: 12, color: T.gray400, marginTop: 3 }}>
                {n.date}
              </div>
            </div>
          ))}
        </div>
      );

    if (active === "certs")
      return (
        <div>
          <h3
            style={{
              fontSize: 17,

              fontWeight: 800,

              color: T.indigo,

              marginBottom: 16,
            }}
          >
            Certificates & Rankings
          </h3>

          <div
            style={{
              background: T.gray50,

              borderRadius: 12,

              padding: "28px 20px",

              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 32, marginBottom: 10 }}>🏆</div>

            <div style={{ fontWeight: 700, color: T.gray800, marginBottom: 6 }}>
              No Certificates Yet
            </div>

            <div style={{ fontSize: 13, color: T.gray600 }}>
              Complete your first exam to earn your digital certificate and view
              your State, District & Taluka rankings.
            </div>
          </div>
        </div>
      );

    if (active === "monthly")
      return (
        <div>
          <h3
            style={{
              fontSize: 17,

              fontWeight: 800,

              color: T.indigo,

              marginBottom: 16,
            }}
          >
            Monthly Practice Exams
          </h3>

          <div
            style={{
              background: T.gray50,

              borderRadius: 12,

              padding: "28px 20px",

              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 32, marginBottom: 10 }}>📅</div>

            <div style={{ fontWeight: 700, color: T.gray800, marginBottom: 6 }}>
              Starts July 2026
            </div>

            <div style={{ fontSize: 13, color: T.gray600 }}>
              Monthly practice tests run from July 2026 to March 2027. You'll be
              notified when the first one is live.
            </div>
          </div>
        </div>
      );

    if (active === "reports")
      return (
        <div>
          <h3
            style={{
              fontSize: 17,

              fontWeight: 800,

              color: T.indigo,

              marginBottom: 16,
            }}
          >
            Performance Analysis
          </h3>

          <div
            style={{
              background: T.gray50,

              borderRadius: 12,

              padding: "28px 20px",

              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 32, marginBottom: 10 }}>📈</div>

            <div style={{ fontWeight: 700, color: T.gray800, marginBottom: 6 }}>
              No Reports Yet
            </div>

            <div style={{ fontSize: 13, color: T.gray600 }}>
              Your performance report will appear here after completing your
              first mock test.
            </div>
          </div>
        </div>
      );

    // Default: Dashboard

    return (
      <div>
        <div
          style={{
            background: `linear-gradient(135deg, ${T.saffron} 0%, #E67000 100%)`,

            borderRadius: 12,

            padding: "16px 20px",

            marginBottom: 20,

            color: T.white,
          }}
        >
          <div
            style={{
              fontSize: 11,

              opacity: 0.8,

              letterSpacing: "0.06em",

              textTransform: "uppercase",

              marginBottom: 4,
            }}
          >
            Upcoming Exam
          </div>

          <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 3 }}>
            {upcomingExam.title}
          </div>

          <div style={{ fontSize: 13, opacity: 0.9 }}>
            📅 {upcomingExam.date} · {upcomingExam.time} ·{" "}
            {upcomingExam.duration}
          </div>
        </div>

        <div
          style={{
            display: "grid",

            gridTemplateColumns: "1fr 1fr",

            gap: 12,

            marginBottom: 20,
          }}
        >
          {tiles.map((t, i) => (
            <div
              key={i}
              onClick={() =>
                setActive(["mock", "monthly", "certs", "reports"][i])
              }
              style={{
                background: T.white,

                border: `1px solid ${T.gray200}`,

                borderRadius: 12,

                padding: "14px 16px",

                cursor: "pointer",
              }}
            >
              <div style={{ fontSize: 22, marginBottom: 6 }}>{t.icon}</div>

              <div style={{ fontSize: 13, fontWeight: 600, color: T.gray800 }}>
                {t.label}
              </div>

              <div
                style={{
                  fontSize: 12,

                  color: t.color,

                  fontWeight: 700,

                  marginTop: 2,
                }}
              >
                {t.value}
              </div>
            </div>
          ))}
        </div>

        <div
          style={{
            background: T.gray50,

            borderRadius: 12,

            padding: "14px 16px",
          }}
        >
          <div
            style={{
              fontSize: 12,

              fontWeight: 700,

              color: T.gray600,

              letterSpacing: "0.06em",

              textTransform: "uppercase",

              marginBottom: 10,
            }}
          >
            Quick Actions
          </div>

          {[
            {
              label: "Start Mock Test 1",

              sub: "90 min · Full syllabus",

              action: "mock",
            },

            {
              label: "View Latest Updates",

              sub: "3 new announcements",

              action: "updates",
            },
          ].map((item, i) => (
            <div
              key={i}
              onClick={() => setActive(item.action)}
              style={{
                display: "flex",

                justifyContent: "space-between",

                alignItems: "center",

                padding: "10px 0",

                borderBottom: i === 0 ? `1px solid ${T.gray200}` : "none",

                cursor: "pointer",
              }}
            >
              <div>
                <div
                  style={{ fontSize: 13, fontWeight: 600, color: T.gray800 }}
                >
                  {item.label}
                </div>

                <div style={{ fontSize: 12, color: T.gray600 }}>{item.sub}</div>
              </div>

              <span style={{ color: T.saffron, fontSize: 16 }}>→</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        minHeight: "100vh",

        background: T.gray100,

        fontFamily: "'Segoe UI', system-ui, sans-serif",
      }}
    >
      <div
        style={{
          background: T.indigo,

          color: T.white,

          padding: "12px 20px",

          display: "flex",

          justifyContent: "space-between",

          alignItems: "center",

          position: "sticky",

          top: 0,

          zIndex: 10,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 20 }}>🎓</span>

          <div>
            <div style={{ fontWeight: 800, fontSize: 14 }}>Shabbas Academy</div>

            <div style={{ fontSize: 11, opacity: 0.6 }}>Student Portal</div>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 12, fontWeight: 600 }}>{user.username}</div>

            <div style={{ fontSize: 11, opacity: 0.6 }}>Student</div>
          </div>

          <Btn onClick={onLogout} variant="ghost" small>
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 13 }}>
              Logout
            </span>
          </Btn>
        </div>
      </div>

      <div
        style={{
          background: T.white,

          borderBottom: `1px solid ${T.gray200}`,

          overflowX: "auto",

          display: "flex",

          padding: "0 12px",
        }}
      >
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActive(item.id)}
            style={{
              padding: "12px 14px",

              border: "none",

              background: "none",

              cursor: "pointer",

              whiteSpace: "nowrap",

              fontSize: 13,

              fontWeight: active === item.id ? 700 : 500,

              color: active === item.id ? T.saffron : T.gray600,

              borderBottom:
                active === item.id
                  ? `2.5px solid ${T.saffron}`
                  : "2.5px solid transparent",

              display: "flex",

              alignItems: "center",

              gap: 5,

              transition: "color 0.15s",
            }}
          >
            {item.icon} {item.label}
          </button>
        ))}
      </div>

      <div style={{ maxWidth: 680, margin: "0 auto", padding: "20px 16px" }}>
        {renderContent()}
      </div>
    </div>
  );
};